import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {APPLICATION_REDUCER_STATE_ID} from './application_constants';

export interface AgensState {
  areExtractedDataOpen: boolean;
}

const initialState: AgensState = {
  areExtractedDataOpen: true,
};

export const applicationSlice = createSlice({
  name: APPLICATION_REDUCER_STATE_ID,
  initialState,
  reducers: {
    setAreExtractedDataOpen: (state, action: PayloadAction<boolean>) => {
      state.areExtractedDataOpen = action.payload;
    },
  },
});
